module.exports = __webpack_public_path__ + "img/logo_h2_nm.64979d9f.png";